import { ShaderMaterial, Uniform, Vector2, GLSL3 } from 'three';

import fullscreenVert from '../shaders/fullscreen.vert?raw';
import kuwaharaFrag from '../shaders/kuwahara.frag?raw';

export interface KuwaharaMaterial extends ShaderMaterial {
  uniforms: {
    tColor: Uniform<unknown>;
    uResolution: Uniform<Vector2>;
    uRadius: Uniform<number>;
  };
}

export function createKuwaharaMaterial(): KuwaharaMaterial {
  return new ShaderMaterial({
    glslVersion: GLSL3,
    vertexShader: fullscreenVert,
    fragmentShader: kuwaharaFrag,
    uniforms: {
      tColor: new Uniform(null),
      uResolution: new Uniform(new Vector2(1, 1)),
      uRadius: new Uniform(2),
    },
    depthTest: false,
    depthWrite: false,
  }) as KuwaharaMaterial;
}
